import { NgStyle } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { ProposalHistoryCourse } from "@app/core/domain/proposal-history";
import { CourseHelper } from "@core/domain/helpers/course-helper";
import { IonItem } from "@ionic/angular/standalone";
import { StudyPointsComponent } from "@shared/components/study-points/study-points.component";

@Component({
  selector: "pa-history-course-item",
  templateUrl: "./history-course-item.component.html",
  styleUrls: ["./history-course-item.component.scss"],
  imports: [NgStyle, StudyPointsComponent, IonItem],
})
export class HistoryCourseItemComponent {
  @Input() course!: ProposalHistoryCourse;
  protected courseHelper = inject(CourseHelper);
}
